module.exports = __webpack_public_path__ + "img/lexue.0e52c592.png";